import React, { useEffect, useMemo, useRef } from "react";
import { Button, Result, Space, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { postMorningSubscriptionReturnLog } from "../../../services/morningSubscriptionReturnApi";
import { getUserInfo } from "../../../services/localStorage";
import {
  SUBSCRIPTION_PAYMENT_PACKAGE_SESSION_KEY,
  normalizeSubscriptionPackageCodeForPaymentLink,
} from "../../../utils/resolveExternalSubscriptionPaymentLink";

const { Paragraph, Text } = Typography;

function collectQueryParams(search) {
  const params = new URLSearchParams(search || "");
  const out = {};
  params.forEach((value, key) => {
    out[key] = value;
  });
  return out;
}

export default function SubscriptionPaymentSuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const loggedRef = useRef(false);

  const queryParams = useMemo(
    () => collectQueryParams(location.search),
    [location.search],
  );

  const packageCode = useMemo(() => {
    const fromUrl =
      queryParams.package ||
      queryParams.packageCode ||
      queryParams.Package ||
      queryParams.tier;
    const fromSession =
      typeof sessionStorage !== "undefined"
        ? sessionStorage.getItem(SUBSCRIPTION_PAYMENT_PACKAGE_SESSION_KEY)
        : null;
    return (
      normalizeSubscriptionPackageCodeForPaymentLink(fromUrl || fromSession) || null
    );
  }, [queryParams]);

  const isLoggedIn = getUserInfo() != null;

  useEffect(() => {
    if (loggedRef.current) return;
    loggedRef.current = true;

    postMorningSubscriptionReturnLog({
      packageCode,
      queryParams,
      rawQueryString: location.search ? location.search.replace(/^\?/, "") : "",
    }).catch(() => {});
  }, [location.search, packageCode, queryParams]);

  const tierLabel = packageCode || "—";

  return (
    <div
      style={{
        inlineSize: "100%",
        maxInlineSize: 760,
        margin: "24px auto",
        padding: "0 12px",
      }}
    >
      <Result
        status="success"
        title="✅ הוראת הקבע נקלטה בהצלחה"
        subTitle={
          <Space direction="vertical" size="small" style={{ textAlign: "center" }}>
            <Paragraph style={{ margin: 0 }}>
              בקשת החיוב החודשי התקבלה במערכת HotelsRiver.
            </Paragraph>
            <Paragraph style={{ margin: 0 }}>
              החבילה שנבחרה: <Text strong>{tierLabel}</Text>
            </Paragraph>
            <Paragraph style={{ margin: 0 }} type="secondary">
              לאחר אימות התשלום המנוי יעודכן אוטומטית.
            </Paragraph>
          </Space>
        }
        extra={
          <Space wrap>
            {isLoggedIn ? (
              <Button type="primary" onClick={() => navigate("/p/dashboard")}>
                מעבר לדשבורד
              </Button>
            ) : null}
            <Button
              type={isLoggedIn ? "default" : "primary"}
              onClick={() => navigate("/")}
            >
              חזרה לעמוד הבית
            </Button>
          </Space>
        }
      />
    </div>
  );
}
